// Multilanguage Support - Multiple Indian Languages
export const translations = {
  en: {
    home: 'HOME',
    about: 'ABOUT US',
    services: 'SERVICES',
    schemes: 'SCHEMES',
    gallery: 'GALLERY',
    contact: 'CONTACT',
    villageMap: 'VILLAGE MAP',
    announcements: 'ANNOUNCEMENTS',
    importantLinks: 'IMPORTANT LINKS',
    budget: 'BUDGET',
    rightToInfo: 'RIGHT TO INFORMATION (RTI)',
    rightToService: 'RIGHT TO SERVICE (RTS)',
    more: 'MORE',
    introduction: 'INTRODUCTION',
    keyOfficials: 'KEY OFFICIALS',
    welcome: 'Welcome to Grampanchayat Nashera',
    welcomeDesc: 'Dedicated to the development of our village and service to citizens',
    ourServices: 'Our Services',
    birthCert: 'Birth Certificate',
    deathCert: 'Death Certificate',
    incomeCert: 'Income Certificate',
    domicileCert: 'Domicile Certificate',
    aboutVillage: 'About Village',
    aboutDesc: 'Nashera is a beautiful village known for its rich culture and tradition.',
    population: 'Population',
    area: 'Area',
    wards: 'Wards',
    contactUs: 'Contact Us',
    address: 'Address',
    phone: 'Phone',
    email: 'Email',
    sarpanch: 'Sarpanch',
    viewMore: 'View More',
    applyOnline: 'Apply Online',
    photoGallery: 'Photo Gallery',
    whatsNew: 'What\'s New',
    usefulLinks: 'Useful Links',
    connectWithUs: 'Connect with Us',
    contactDetails: 'Contact Details',
    location: 'Location',
    terms: 'Terms & Conditions',
    privacy: 'Privacy Policy'
  },
  mr: {
    home: 'मुख्य पृष्ठ',
    about: 'आमच्याबद्दल',
    services: 'सेवा',
    schemes: 'योजना',
    gallery: 'गॅलरी',
    contact: 'संपर्क',
    villageMap: 'गावाचा नकाशा',
    announcements: 'घोषणा',
    importantLinks: 'महत्वपूर्ण दुवे',
    budget: 'अर्थसंकल्प',
    rightToInfo: 'माहितीचा अधिकार (RTI)',
    rightToService: 'सेवेचा अधिकार (RTS)',
    more: 'अधिक',
    introduction: 'परिचय',
    keyOfficials: 'मुख्य अधिकारी',
    welcome: 'ग्रामपंचायत नाशेरा येथे आपले स्वागत आहे',
    welcomeDesc: 'आमच्या गावाच्या विकासासाठी आणि नागरिकांच्या सेवेसाठी समर्पित',
    ourServices: 'आमच्या सेवा',
    birthCert: 'जन्म प्रमाणपत्र',
    deathCert: 'मृत्यू प्रमाणपत्र',
    incomeCert: 'उत्पन्न प्रमाणपत्र',
    domicileCert: 'अधिवास प्रमाणपत्र',
    aboutVillage: 'गावाबद्दल',
    aboutDesc: 'नाशेरा हे एक सुंदर गाव आहे जे त्याच्या समृद्ध संस्कृती आणि परंपरेसाठी ओळखले जाते.',
    population: 'लोकसंख्या',
    area: 'क्षेत्रफळ',
    wards: 'प्रभाग',
    contactUs: 'आमच्याशी संपर्क साधा',
    address: 'पत्ता',
    phone: 'फोन',
    email: 'ईमेल',
    sarpanch: 'सरपंच',
    viewMore: 'अधिक पहा',
    applyOnline: 'ऑनलाइन अर्ज करा',
    photoGallery: 'फोटो गॅलरी',
    whatsNew: 'नवीन काय आहे',
    usefulLinks: 'उपयुक्त दुवे',
    connectWithUs: 'आमच्याशी जुडा',
    contactDetails: 'संपर्क तपशील',
    location: 'स्थान',
    terms: 'नियम आणि अटी',
    privacy: 'गोपनीयता धोरण'
  },
  hi: {
    home: 'मुख्य पृष्ठ',
    about: 'हमारे बारे में',
    services: 'सेवाएं',
    schemes: 'योजनाएं',
    gallery: 'गैलरी',
    contact: 'संपर्क',
    villageMap: 'गांव का नक्शा',
    announcements: 'घोषणाएं',
    importantLinks: 'महत्वपूर्ण लिंक',
    budget: 'बजट',
    rightToInfo: 'सूचना का अधिकार (RTI)',
    rightToService: 'सेवा का अधिकार (RTS)',
    more: 'और',
    introduction: 'परिचय',
    keyOfficials: 'मुख्य अधिकारी',
    welcome: 'ग्राम पंचायत नाशेरा में आपका स्वागत है',
    welcomeDesc: 'हमारे गांव के विकास और नागरिकों की सेवा के लिए समर्पित'
  },
  gu: {
    home: 'મુખ્ય પૃષ્ઠ',
    about: 'અમારા વિશે',
    services: 'સેવાઓ',
    schemes: 'યોજનાઓ',
    gallery: 'ગેલેરી',
    contact: 'સંપર્ક',
    welcome: 'ગ્રામપંચાયત નાશેરામાં આપનું સ્વાગત છે'
  }
};